// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';
// import PdfPreview from "../../../Common/PDFPreview"
// import { RingLoader } from 'react-spinners';
// import BackButton from "../../../Common/Buttons/BackButton";

// const API_URL = process.env.REACT_APP_API;

// const StockReportDetail = () => {
//   const location = useLocation();
//   // const { fromDate, toDate, itemCode } = location.state;
//   const companyCode = sessionStorage.getItem("Company_Code");
//   const companyName = sessionStorage.getItem('Company_Name')

//   const searchParams = new URLSearchParams(location.search);
//   const itemCode = searchParams.get('itemCode');
//   const toDate = searchParams.get('toDate');
//   const fromDate = searchParams.get('fromDate');

//   const [groupedData, setGroupedData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [pdfPreview, setPdfPreview] = useState([])
//   const [showPreview, setShowPreview] = useState(false);

//   const navigate = useNavigate();

//   const groupBy = (array, key) => {
//     return array.reduce((result, currentItem) => {
//       const groupKey = currentItem[key];
//       if (!result[groupKey]) {
//         result[groupKey] = [];
//       }
//       result[groupKey].push(currentItem);
//       return result;
//     }, {});
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return `${String(date.getDate()).padStart(2, "0")}/${String(
//       date.getMonth() + 1
//     ).padStart(2, "0")}/${date.getFullYear()}`;
//   };

//   useEffect(() => {
//     const fetchStockBookDetailReport = async () => {
//       try {
//         // const response = await fetch(
//         //   `${API_URL}/stock-book-detail?doc_date=${toDate}&company_code=${companyCode}&Item_Code=${itemCode}`
//         // );
//         const response = await fetch(
//   `${API_URL}/stock-book-detail?doc_date=${toDate}&from_date=${fromDate}&company_code=${companyCode}&Item_Code=${itemCode}`
// );
//         const result = await response.json();
//         const grouped = groupBy(result.data || [], "System_Name_E");
//         setGroupedData(grouped);
//       } catch (error) {
//         console.error("Error fetching stock book detail report:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStockBookDetailReport();
//   }, [toDate, itemCode]);

//   const handleBack = () => {
//     navigate('/stock-book')
//   }

//   const generatePDF = () => {
//     const doc = new jsPDF("landscape", "mm", "a4");
//     const pageHeight = doc.internal.pageSize.height;
//     const margin = 10; 

//     const title = "Stock Book Detail Report";

//     doc.setFontSize(14);
//     doc.text(title, 10, 10);
//     doc.setFontSize(10);
//     doc.text(
//       `From Date: ${formatDate(fromDate)} | To Date: ${formatDate(toDate)}`,
//       10,
//       20
//     );

//     let currentY = 30; 

//     Object.keys(groupedData).forEach((group, groupIndex) => {
//       if (currentY + 20 > pageHeight - margin) {
//         doc.addPage();
//         currentY = margin; 
//       }

//       doc.setFontSize(12);
//       doc.setTextColor(40);
//       doc.text(`Item Name: ${group.toUpperCase()}`, 10, currentY);
//       currentY += 10;

//       const tableData = groupedData[group].map((row) => [
//         formatDate(row.doc_date),
//         (parseFloat(row.opqntl) || 0).toFixed(2),
//         (parseFloat(row.inwqntl) || 0).toFixed(2),
//         (parseFloat(row.outqntl) || 0).toFixed(2),
//         (parseFloat(row.bal) || 0).toFixed(2),
//         (row.Marka),
//         (row.Tran_Type),
//         (row.DoNO),
//         (row.doc_no),
//         (row.partyShortname),
//         (row.MillShortName)
//       ]);

//       doc.autoTable({
//         startY: currentY,
//         head: [
//           [
//             "Date",
//             "Opening Qty",
//             "Inward Qty",
//             "Outward Qty",
//             "Balance",
//             "Marka",
//             "Tran Type",
//             "DO No",
//             "Doc No",
//             "Party Name",
//             "Mill Short Name",

//           ],
//         ],
//         body: [...tableData], 
//         styles: { fontSize: 8, cellPadding: 3, halign: "right" },
//         headStyles: { fillColor: [240, 240, 240], textColor: 0 },
//         columnStyles: { 0: { halign: "center" } }, 
//         didDrawPage: (data) => {
//           currentY = data.cursor.y; 
//         },
//       });

//       currentY = doc.lastAutoTable.finalY + 10;
//     });

//     const pdfBlob = doc.output("blob");
//     const pdfUrl = URL.createObjectURL(pdfBlob);
//     setPdfPreview(pdfUrl);
//     setShowPreview(true);
//   };

//   if (loading) return <div>{loading && (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100%",
//       }}
//     >
//       <RingLoader />
//     </div>
//   )}
//   </div>;

//   return (
//     <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
//       <BackButton onClick={handleBack} />
//       <div className="d-flex mb-3 mt-0.5">
//         {showPreview && pdfPreview && (
//           <PdfPreview pdfData={pdfPreview} apiData={groupedData} label={"Stock Book Detail Report"} />
//         )}
//         <button
//           onClick={generatePDF}
//           className="print-button"
//           style={{ fontSize: "16px", height: "50px", marginTop: "10px" }}
//         >
//           PDF Preview
//         </button>

//       </div>
//       <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#333", marginTop: "-60px" }}>
//         {companyName}
//       </h2>
//       <p style={{ textAlign: "center", fontSize: "14px", marginBottom: "20px" }}>
//         <strong>Stock Book Detail Report From Date:</strong> {formatDate(fromDate)} |{" "}
//         <strong>To Date:</strong> {formatDate(toDate)}
//       </p>
//       {Object.keys(groupedData).map((group, index) => (
//         <div key={index} style={{ marginBottom: "30px" }}>
//           <h3
//             style={{
//               backgroundColor: "#f4f4f4",
//               padding: "10px",
//               textAlign: "left",
//             }}
//           >
//             {group.toUpperCase()}
//           </h3>
//           <table
//             border="1"
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               fontSize: "14px",
//             }}
//           >
//             <thead>
//               <tr>
//                 <th style={{ textAlign: "center", padding: "10px" }}>Date</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>
//                   Opening Qty
//                 </th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>
//                   Inward Qty
//                 </th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>
//                   Outward Qty
//                 </th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Balance</th>
//                 <th style={{ textAlign: "center", padding: "10px" }}>
//                   Marka
//                 </th>
//                 <th style={{ textAlign: "center", padding: "10px" }}>
//                   Trans Type
//                 </th>
//                 <th style={{ textAlign: "center", padding: "10px" }}>
//                   DO
//                 </th>
//                 <th style={{ textAlign: "center", padding: "10px" }}>
//                   Doc No
//                 </th>
//                 <th style={{ textAlign: "left", padding: "10px" }}>
//                   Party Name
//                 </th>
//                 <th style={{ textAlign: "left", padding: "10px" }}>
//                   Mill Name
//                 </th>

//               </tr>
//             </thead>
//             <tbody>
//               {groupedData[group].map((row, rowIndex) => (
//                 <tr
//                   key={rowIndex}
//                   style={{
//                     backgroundColor:
//                       rowIndex % 2 === 0 ? "#f9f9f9" : "white",
//                   }}
//                 >
//                   <td style={{ textAlign: "center" }}>
//                     {formatDate(row.doc_date)}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {(parseFloat(row.opqntl) || 0).toFixed(2)}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {(parseFloat(row.inwqntl) || 0).toFixed(2)}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {(parseFloat(row.outqntl) || 0).toFixed(2)}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {(parseFloat(row.bal) || 0).toFixed(2)}
//                   </td>
//                   <td style={{ textAlign: "center" }}>{row.Marka}</td>
//                   <td style={{ textAlign: "center" }}>{row.Tran_Type}</td>
//                   <td style={{ textAlign: "center" }}>{row.DoNO}</td>
//                   <td style={{ textAlign: "center" }}>{row.doc_no}</td>
//                   <td style={{ textAlign: "left" }}>{row.partyShortname}</td>
//                   <td style={{ textAlign: "left" }}>{row.MillShortName}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default StockReportDetail;















// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';
// import PdfPreview from "../../../Common/PDFPreview"
// import { RingLoader } from 'react-spinners';
// import BackButton from "../../../Common/Buttons/BackButton";

// const API_URL = process.env.REACT_APP_API;

// const StockReportDetail = () => {
//   const location = useLocation();
//   const companyCode = sessionStorage.getItem("Company_Code");
//   const companyName = sessionStorage.getItem('Company_Name')

//   const searchParams = new URLSearchParams(location.search);
//   const itemCode = searchParams.get('itemCode');
//   const toDate = searchParams.get('toDate');
//   const fromDate = searchParams.get('fromDate');

//   const [groupedData, setGroupedData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [pdfPreview, setPdfPreview] = useState([])
//   const [showPreview, setShowPreview] = useState(false);

//   const navigate = useNavigate();

//   const groupBy = (array, key) => {
//     return array.reduce((result, currentItem) => {
//       const groupKey = currentItem[key];
//       if (!result[groupKey]) {
//         result[groupKey] = [];
//       }
//       result[groupKey].push(currentItem);
//       return result;
//     }, {});
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return `${String(date.getDate()).padStart(2, "0")}/${String(
//       date.getMonth() + 1
//     ).padStart(2, "0")}/${date.getFullYear()}`;
//   };

//   // ✅ Helper to calculate totals for a group
//   const calculateTotals = (rows) => {
//     return rows.reduce(
//       (acc, row) => {
//         acc.totalInward += parseFloat(row.inwqntl) || 0;
//         acc.totalOutward += parseFloat(row.outqntl) || 0;
//         return acc;
//       },
//       { totalInward: 0, totalOutward: 0 }
//     );
//   };

//   useEffect(() => {
//     const fetchStockBookDetailReport = async () => {
//       try {
//         const response = await fetch(
//           `${API_URL}/stock-book-detail?doc_date=${toDate}&from_date=${fromDate}&company_code=${companyCode}&Item_Code=${itemCode}`
//         );
//         const result = await response.json();
//         const grouped = groupBy(result.data || [], "System_Name_E");
//         setGroupedData(grouped);
//       } catch (error) {
//         console.error("Error fetching stock book detail report:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStockBookDetailReport();
//   }, [toDate, itemCode]);

//   const handleBack = () => {
//     navigate('/stock-book')
//   }

//   const generatePDF = () => {
//     const doc = new jsPDF("landscape", "mm", "a4");
//     const pageHeight = doc.internal.pageSize.height;
//     const margin = 10;

//     const title = "Stock Book Detail Report";

//     doc.setFontSize(14);
//     doc.text(title, 10, 10);
//     doc.setFontSize(10);
//     doc.text(
//       `From Date: ${formatDate(fromDate)} | To Date: ${formatDate(toDate)}`,
//       10,
//       20
//     );

//     let currentY = 30;

//     Object.keys(groupedData).forEach((group) => {
//       if (currentY + 20 > pageHeight - margin) {
//         doc.addPage();
//         currentY = margin;
//       }

//       doc.setFontSize(12);
//       doc.setTextColor(40);
//       doc.text(`Item Name: ${group.toUpperCase()}`, 10, currentY);
//       currentY += 10;

//       const { totalInward, totalOutward } = calculateTotals(groupedData[group]);

//       const tableData = groupedData[group].map((row) => [
//         formatDate(row.doc_date),
//         (parseFloat(row.opqntl) || 0).toFixed(2),
//         (parseFloat(row.inwqntl) || 0).toFixed(2),
//         (parseFloat(row.outqntl) || 0).toFixed(2),
//         (parseFloat(row.bal) || 0).toFixed(2),
//         row.Marka,
//         row.Tran_Type,
//         row.DoNO,
//         row.doc_no,
//         row.partyShortname,
//         row.MillShortName,
//       ]);

//       // ✅ Add totals row at the bottom of PDF table
//       tableData.push([
//         "Total",
//         "",
//         totalInward.toFixed(2),
//         totalOutward.toFixed(2),
//         "",
//         "", "", "", "", "", ""
//       ]);

//       doc.autoTable({
//         startY: currentY,
//         head: [
//           [
//             "Date", "Opening Qty", "Inward Qty", "Outward Qty", "Balance",
//             "Marka", "Tran Type", "DO No", "Doc No", "Party Name", "Mill Short Name",
//           ],
//         ],
//         body: tableData,
//         styles: { fontSize: 8, cellPadding: 3, halign: "right" },
//         headStyles: { fillColor: [240, 240, 240], textColor: 0 },
//         columnStyles: { 0: { halign: "center" } },
//         // ✅ Bold the totals row in PDF
//         didParseCell: (data) => {
//           if (data.row.index === tableData.length - 1) {
//             data.cell.styles.fontStyle = "bold";
//             data.cell.styles.fillColor = [220, 235, 255];
//           }
//         },
//         didDrawPage: (data) => {
//           currentY = data.cursor.y;
//         },
//       });

//       currentY = doc.lastAutoTable.finalY + 10;
//     });

//     const pdfBlob = doc.output("blob");
//     const pdfUrl = URL.createObjectURL(pdfBlob);
//     setPdfPreview(pdfUrl);
//     setShowPreview(true);
//   };

//   if (loading) return (
//     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//       <RingLoader />
//     </div>
//   );

//   return (
//     <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
//       <BackButton onClick={handleBack} />
//       <div className="d-flex mb-3 mt-0.5">
//         {showPreview && pdfPreview && (
//           <PdfPreview pdfData={pdfPreview} apiData={groupedData} label={"Stock Book Detail Report"} />
//         )}
//         <button
//           onClick={generatePDF}
//           className="print-button"
//           style={{ fontSize: "16px", height: "50px", marginTop: "10px" }}
//         >
//           PDF Preview
//         </button>
//       </div>

//       <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#333", marginTop: "-60px" }}>
//         {companyName}
//       </h2>
//       <p style={{ textAlign: "center", fontSize: "14px", marginBottom: "20px" }}>
//         <strong>Stock Book Detail Report From Date:</strong> {formatDate(fromDate)} |{" "}
//         <strong>To Date:</strong> {formatDate(toDate)}
//       </p>

//       {Object.keys(groupedData).map((group, index) => {
//         // ✅ Calculate totals per group
//         const { totalInward, totalOutward } = calculateTotals(groupedData[group]);

//         return (
//           <div key={index} style={{ marginBottom: "30px" }}>
//             <h3 style={{ backgroundColor: "#f4f4f4", padding: "10px", textAlign: "left" }}>
//               {group.toUpperCase()}
//             </h3>
//             <table border="1" style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
//               <thead>
//                 <tr>
//                   <th style={{ textAlign: "center", padding: "10px" }}>Date</th>
//                   <th style={{ textAlign: "right", padding: "10px" }}>Opening Qty</th>
//                   <th style={{ textAlign: "right", padding: "10px" }}>Inward Qty</th>
//                   <th style={{ textAlign: "right", padding: "10px" }}>Outward Qty</th>
//                   <th style={{ textAlign: "right", padding: "10px" }}>Balance</th>
//                   <th style={{ textAlign: "center", padding: "10px" }}>Marka</th>
//                   <th style={{ textAlign: "center", padding: "10px" }}>Trans Type</th>
//                   <th style={{ textAlign: "center", padding: "10px" }}>DO</th>
//                   <th style={{ textAlign: "center", padding: "10px" }}>Doc No</th>
//                   <th style={{ textAlign: "left", padding: "10px" }}>Party Name</th>
//                   <th style={{ textAlign: "left", padding: "10px" }}>Mill Name</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {groupedData[group].map((row, rowIndex) => (
//                   <tr key={rowIndex} style={{ backgroundColor: rowIndex % 2 === 0 ? "#f9f9f9" : "white" }}>
//                     <td style={{ textAlign: "center" }}>{formatDate(row.doc_date)}</td>
//                     <td style={{ textAlign: "right" }}>{(parseFloat(row.opqntl) || 0).toFixed(2)}</td>
//                     <td style={{ textAlign: "right" }}>{(parseFloat(row.inwqntl) || 0).toFixed(2)}</td>
//                     <td style={{ textAlign: "right" }}>{(parseFloat(row.outqntl) || 0).toFixed(2)}</td>
//                     <td style={{ textAlign: "right" }}>{(parseFloat(row.bal) || 0).toFixed(2)}</td>
//                     <td style={{ textAlign: "center" }}>{row.Marka}</td>
//                     <td style={{ textAlign: "center" }}>{row.Tran_Type}</td>
//                     <td style={{ textAlign: "center" }}>{row.DoNO}</td>
//                     <td style={{ textAlign: "center" }}>{row.doc_no}</td>
//                     <td style={{ textAlign: "left" }}>{row.partyShortname}</td>
//                     <td style={{ textAlign: "left" }}>{row.MillShortName}</td>
//                   </tr>
//                 ))}
//               </tbody>

//               {/* ✅ Totals footer row */}
//               <tfoot>
//                 <tr style={{ backgroundColor: "#dce9ff", fontWeight: "bold", fontSize: "14px" }}>
//                   <td style={{ textAlign: "center", padding: "10px" }}>Total</td>
//                   <td style={{ padding: "10px" }}></td>
//                   <td style={{ textAlign: "right", padding: "10px" }}>{totalInward.toFixed(2)}</td>
//                   <td style={{ textAlign: "right", padding: "10px" }}>{totalOutward.toFixed(2)}</td>
//                   <td style={{ padding: "10px" }}></td>
//                   <td style={{ padding: "10px" }}></td>
//                   <td style={{ padding: "10px" }}></td>
//                   <td style={{ padding: "10px" }}></td>
//                   <td style={{ padding: "10px" }}></td>
//                   <td style={{ padding: "10px" }}></td>
//                   <td style={{ padding: "10px" }}></td>
//                 </tr>
//               </tfoot>
//             </table>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default StockReportDetail;













import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import PdfPreview from "../../../Common/PDFPreview";
import { RingLoader } from "react-spinners";
import BackButton from "../../../Common/Buttons/BackButton";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";

const API_URL = process.env.REACT_APP_API;

/* ─── icons (inline SVG to avoid extra deps) ─── */
const IconPDF = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

const IconXLS = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="2" width="20" height="20" rx="2" />
    <line x1="2" y1="8" x2="22" y2="8" />
    <line x1="2" y1="14" x2="22" y2="14" />
    <line x1="8" y1="8" x2="8" y2="22" />
    <line x1="14" y1="8" x2="14" y2="22" />
  </svg>
);

const SortIcon = ({ direction }) => (
  <span style={{ display: "inline-flex", flexDirection: "column", marginLeft: 4, lineHeight: 1 }}>
    <span style={{ opacity: direction === "asc" ? 1 : 0.3, fontSize: 9 }}>▲</span>
    <span style={{ opacity: direction === "desc" ? 1 : 0.3, fontSize: 9 }}>▼</span>
  </span>
);

/* ─── column config ─── */
const COLUMNS = [
  { key: "doc_date",       label: "Date",          align: "center", type: "date" },
  { key: "opqntl",        label: "Opening Qty",   align: "right",  type: "number" },
  { key: "inwqntl",       label: "Inward Qty",    align: "right",  type: "number" },
  { key: "outqntl",       label: "Outward Qty",   align: "right",  type: "number" },
  { key: "bal",           label: "Balance",       align: "right",  type: "number" },
  { key: "Marka",         label: "Marka",         align: "center", type: "string" },
  { key: "Tran_Type",     label: "Trans Type",    align: "center", type: "string" },
  { key: "DoNO",          label: "DO No",         align: "center", type: "string" },
  { key: "doc_no",        label: "Doc No",        align: "center", type: "string" },
  { key: "partyShortname",label: "Party Name",    align: "left",   type: "string" },
  { key: "MillShortName", label: "Mill Name",     align: "left",   type: "string" },
];

/* ─── helpers ─── */
const formatDate = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  return `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}/${dt.getFullYear()}`;
};

const fnum = (v, decimals = 2) => (parseFloat(v) || 0).toFixed(decimals);

const groupBy = (arr, key) =>
  arr.reduce((acc, item) => {
    (acc[item[key]] = acc[item[key]] || []).push(item);
    return acc;
  }, {});

const calcTotals = (rows) =>
  rows.reduce(
    (acc, r) => {
      acc.totalInward  += parseFloat(r.inwqntl) || 0;
      acc.totalOutward += parseFloat(r.outqntl) || 0;
      return acc;
    },
    { totalInward: 0, totalOutward: 0 }
  );

/* ─── compare fn for sorting ─── */
const compareValues = (a, b, col, dir) => {
  let va = a[col], vb = b[col];
  if (col === "doc_date") { va = new Date(va); vb = new Date(vb); }
  else if (["opqntl","inwqntl","outqntl","bal"].includes(col)) { va = parseFloat(va)||0; vb = parseFloat(vb)||0; }
  else { va = (va||"").toString().toLowerCase(); vb = (vb||"").toString().toLowerCase(); }
  return dir === "asc" ? (va > vb ? 1 : va < vb ? -1 : 0) : (va < vb ? 1 : va > vb ? -1 : 0);
};

/* ─── styles ─── */
const S = {
  page:    { padding: "24px 28px", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", background: "#f0f4f8", minHeight: "100vh" },
  topBar:  { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 },
  btnRow:  { display: "flex", gap: 10 },
  btn:     (color) => ({
    display: "inline-flex", alignItems: "center", gap: 8,
    padding: "9px 18px", borderRadius: 8, border: "none", cursor: "pointer",
    fontWeight: 600, fontSize: 13, letterSpacing: 0.3,
    background: color, color: "#fff",
    boxShadow: `0 2px 6px ${color}55`,
    transition: "transform .15s, box-shadow .15s",
  }),
  card:    { background: "#fff", borderRadius: 12, boxShadow: "0 2px 12px rgba(0,0,0,.08)", marginBottom: 28, overflow: "hidden" },
  groupHd: { padding: "12px 18px", background: "linear-gradient(135deg,#1a56db,#2563eb)", color: "#fff", fontWeight: 700, fontSize: 14, letterSpacing: .5 },
  table:   { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th:      (align) => ({
    padding: "9px 12px", textAlign: align, background: "#f8fafc",
    borderBottom: "2px solid #e2e8f0", color: "#475569", fontWeight: 700, fontSize: 12,
    cursor: "pointer", whiteSpace: "nowrap", userSelect: "none",
  }),
  tdBase:  (align, even) => ({
    padding: "8px 12px", textAlign: align, color: "#1e293b",
    borderBottom: "1px solid #f1f5f9", background: even ? "#f8fafc" : "#fff",
    whiteSpace: "nowrap",
  }),
  tfootTd: (align) => ({
    padding: "10px 12px", textAlign: align, fontWeight: 700,
    background: "#dbeafe", color: "#1d4ed8", borderTop: "2px solid #bfdbfe",
    fontSize: 13,
  }),
  title:   { textAlign: "center", fontSize: 22, fontWeight: 700, color: "#1e293b", margin: "0 0 4px" },
  subTitle:{ textAlign: "center", fontSize: 13, color: "#64748b", marginBottom: 20 },
};

/* ══════════════════════════════════════════════════════════ */
const StockReportDetail = () => {
  const location    = useLocation();
  const navigate    = useNavigate();
  const companyCode = sessionStorage.getItem("Company_Code");
    const yearcode = sessionStorage.getItem("Year_Code");
  const companyName = sessionStorage.getItem("Company_Name");

  const searchParams = new URLSearchParams(location.search);
  const itemCode  = searchParams.get("itemCode");
  const toDate    = searchParams.get("toDate");
  const fromDate  = searchParams.get("fromDate");

  const [rawGrouped, setRawGrouped]   = useState({});   // original data
  const [sortState,  setSortState]    = useState({});   // { groupKey: { col, dir } }
  const [loading,    setLoading]      = useState(true);
  const [pdfPreview, setPdfPreview]   = useState(null);
  const [showPreview,setShowPreview]  = useState(false);

  /* sorted view */
  const getSorted = useCallback((group) => {
    const rows = [...(rawGrouped[group] || [])];
    const ss   = sortState[group];
    if (!ss) return rows;
    return rows.sort((a, b) => compareValues(a, b, ss.col, ss.dir));
  }, [rawGrouped, sortState]);

  const handleSort = (group, colKey) => {
    setSortState((prev) => {
      const cur = prev[group];
      const dir = cur?.col === colKey && cur.dir === "asc" ? "desc" : "asc";
      return { ...prev, [group]: { col: colKey, dir } };
    });
  };

  /* fetch */
  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res    = await fetch(`${API_URL}/stock-book-detail?doc_date=${toDate}&from_date=${fromDate}&company_code=${companyCode}&Item_Code=${itemCode}&Year_Code=${yearcode}`);
        const result = await res.json();
        setRawGrouped(groupBy(result.data || [], "System_Name_E"));
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetch_();
  }, [toDate, itemCode]);

  /* ── PDF ── */
  const generatePDF = () => {
    const doc        = new jsPDF("landscape", "mm", "a4");
    const pageHeight = doc.internal.pageSize.height;
    const margin     = 10;
    let   currentY   = 30;

    // Header
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text(companyName || "Company", 148, 10, { align: "center" });
    doc.setFontSize(11);
    doc.setFont(undefined, "normal");
    doc.text("Stock Book Detail Report", 148, 18, { align: "center" });
    doc.setFontSize(9);
    doc.text(`From Date: ${formatDate(fromDate)}   |   To Date: ${formatDate(toDate)}`, 148, 25, { align: "center" });

    Object.keys(rawGrouped).forEach((group) => {
      const rows = getSorted(group);
      if (currentY + 20 > pageHeight - margin) { doc.addPage(); currentY = margin; }

      doc.setFontSize(11);
      doc.setFont(undefined, "bold");
      doc.setTextColor(30, 86, 219);
      doc.text(`Item: ${group.toUpperCase()}`, 10, currentY);
      doc.setTextColor(40);
      currentY += 8;

      const { totalInward, totalOutward } = calcTotals(rows);
      const tableData = rows.map((r) => [
        formatDate(r.doc_date), fnum(r.opqntl), fnum(r.inwqntl), fnum(r.outqntl),
        fnum(r.bal), r.Marka, r.Tran_Type, r.DoNO, r.doc_no, r.partyShortname, r.MillShortName,
      ]);
      tableData.push(["Total", "", totalInward.toFixed(2), totalOutward.toFixed(2), "", "", "", "", "", "", ""]);

      doc.autoTable({
        startY: currentY,
        head:   [COLUMNS.map((c) => c.label)],
        body:   tableData,
        styles: { fontSize: 7.5, cellPadding: 2.5 },
        headStyles: { fillColor: [30, 86, 219], textColor: 255, fontStyle: "bold" },
        alternateRowStyles: { fillColor: [248, 250, 252] },
        columnStyles: {
          0: { halign: "center" }, 1: { halign: "right" }, 2: { halign: "right" },
          3: { halign: "right" }, 4: { halign: "right" }, 5: { halign: "center" },
          6: { halign: "center" }, 7: { halign: "center" }, 8: { halign: "center" },
        },
        didParseCell: (data) => {
          if (data.row.index === tableData.length - 1) {
            data.cell.styles.fontStyle  = "bold";
            data.cell.styles.fillColor  = [219, 234, 254];
            data.cell.styles.textColor  = [29, 78, 216];
          }
        },
        didDrawPage: (data) => { currentY = data.cursor.y; },
      });
      currentY = doc.lastAutoTable.finalY + 12;
    });

    const blob = doc.output("blob");
    setPdfPreview(URL.createObjectURL(blob));
    setShowPreview(true);
  };

  /* ── XLSX export ── */
  const exportXLSX = () => {
    const wb = XLSX.utils.book_new();

    Object.keys(rawGrouped).forEach((group) => {
      const rows = getSorted(group);
      const { totalInward, totalOutward } = calcTotals(rows);

      // Company / report header rows
      const header = [
        [companyName || ""],
        ["Stock Book Detail Report"],
        [`From Date: ${formatDate(fromDate)}   |   To Date: ${formatDate(toDate)}`],
        [],
        [`Item: ${group.toUpperCase()}`],
        [],
        COLUMNS.map((c) => c.label),
      ];

      const dataRows = rows.map((r) => [
        formatDate(r.doc_date),
        parseFloat(fnum(r.opqntl)),
        parseFloat(fnum(r.inwqntl)),
        parseFloat(fnum(r.outqntl)),
        parseFloat(fnum(r.bal)),
        r.Marka        || "",
        r.Tran_Type    || "",
        r.DoNO         || "",
        r.doc_no       || "",
        r.partyShortname  || "",
        r.MillShortName   || "",
      ]);

      const totalRow = ["Total", "", parseFloat(totalInward.toFixed(2)), parseFloat(totalOutward.toFixed(2)), "", "", "", "", "", "", ""];
      const sheetData = [...header, ...dataRows, totalRow];

      const ws = XLSX.utils.aoa_to_sheet(sheetData);

      /* column widths */
      ws["!cols"] = [
        { wch: 14 }, { wch: 13 }, { wch: 13 }, { wch: 14 }, { wch: 12 },
        { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 22 }, { wch: 20 },
      ];

      /* safe sheet name (max 31 chars) */
      const sheetName = group.length > 28 ? group.substring(0, 28) + "..." : group;
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });

    /* summary sheet */
    const summaryRows = [
      [companyName || ""],
      ["Stock Book Detail Report — Summary"],
      [`From Date: ${formatDate(fromDate)}   |   To Date: ${formatDate(toDate)}`],
      [],
      ["Item Name", "Total Inward", "Total Outward"],
    ];
    Object.keys(rawGrouped).forEach((group) => {
      const { totalInward, totalOutward } = calcTotals(rawGrouped[group]);
      summaryRows.push([group, parseFloat(totalInward.toFixed(2)), parseFloat(totalOutward.toFixed(2))]);
    });
    const wsSummary = XLSX.utils.aoa_to_sheet(summaryRows);
    wsSummary["!cols"] = [{ wch: 35 }, { wch: 16 }, { wch: 16 }];
    XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");

    XLSX.writeFile(wb, `StockBookDetailReport_${formatDate(fromDate).replace(/\//g,"-")}_${formatDate(toDate).replace(/\//g,"-")}.xlsx`);
  };

  /* ─── render ─── */
  if (loading) return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <RingLoader color="#2563eb" />
    </div>
  );

  return (
    <div style={S.page}>

      {/* top bar */}
      <div style={S.topBar}>
        <BackButton onClick={() => navigate("/stock-book")} />
        <div style={S.btnRow}>
          {showPreview && pdfPreview && (
            <PdfPreview pdfData={pdfPreview} apiData={rawGrouped} label="Stock Book Detail Report" />
          )}
          <button
            style={S.btn("#e53e3e")}
            onClick={generatePDF}
            onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 4px 12px #e53e3e55"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = `0 2px 6px #e53e3e55`; }}
          >
            <IconPDF /> PDF Preview
          </button>
          <button
            style={S.btn("#16a34a")}
            onClick={exportXLSX}
            onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 4px 12px #16a34a55"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = `0 2px 6px #16a34a55`; }}
          >
            <IconXLS /> Export to Excel
          </button>
        </div>
      </div>

      {/* report heading */}
      <h2 style={S.title}>{companyName}</h2>
      <p style={S.subTitle}>
        <strong>Stock Book Detail Report</strong>&nbsp;&nbsp;|&nbsp;&nbsp;
        From:&nbsp;<strong>{formatDate(fromDate)}</strong>&nbsp;&nbsp;To:&nbsp;<strong>{formatDate(toDate)}</strong>
      </p>

      {/* tables per group */}
      {Object.keys(rawGrouped).map((group) => {
        const rows = getSorted(group);
        const { totalInward, totalOutward } = calcTotals(rows);
        const ss = sortState[group] || {};

        return (
          <div key={group} style={S.card}>
            <div style={S.groupHd}>{group.toUpperCase()}</div>
            <div style={{ overflowX: "auto" }}>
              <table style={S.table}>
                <thead>
                  <tr>
                    {COLUMNS.map((col) => (
                      <th
                        key={col.key}
                        style={S.th(col.align)}
                        onClick={() => handleSort(group, col.key)}
                        title={`Sort by ${col.label}`}
                      >
                        {col.label}
                        <SortIcon direction={ss.col === col.key ? ss.dir : null} />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, i) => (
                    <tr
                      key={i}
                      onMouseEnter={(e) => { e.currentTarget.querySelectorAll("td").forEach((td) => { td.style.background = "#eff6ff"; }); }}
                      onMouseLeave={(e) => {
                        e.currentTarget.querySelectorAll("td").forEach((td) => {
                          td.style.background = i % 2 === 0 ? "#f8fafc" : "#fff";
                        });
                      }}
                    >
                      <td style={S.tdBase("center", i % 2 === 0)}>{formatDate(row.doc_date)}</td>
                      <td style={S.tdBase("right",  i % 2 === 0)}>{fnum(row.opqntl)}</td>
                      <td style={{ ...S.tdBase("right", i % 2 === 0), color: "#16a34a", fontWeight: 500 }}>{formatReadableAmount(fnum(row.inwqntl))}</td>
                      <td style={{ ...S.tdBase("right", i % 2 === 0), color: "#dc2626", fontWeight: 500 }}>{formatReadableAmount(fnum(row.outqntl))}</td>
                      <td style={{ ...S.tdBase("right", i % 2 === 0), fontWeight: 600 }}>{formatReadableAmount(fnum(row.bal))}</td>
                      <td style={S.tdBase("center", i % 2 === 0)}>{row.Marka}</td>
                      <td style={S.tdBase("center", i % 2 === 0)}>
                        <span style={{
                          background: "#e0f2fe", color: "#0369a1", padding: "2px 8px",
                          borderRadius: 20, fontSize: 11, fontWeight: 600,
                        }}>{row.Tran_Type}</span>
                      </td>
                      <td style={S.tdBase("center", i % 2 === 0)}>{row.DoNO}</td>
                      <td style={S.tdBase("center", i % 2 === 0)}>{row.doc_no}</td>
                      <td style={S.tdBase("left",   i % 2 === 0)}>{row.partyShortname}</td>
                      <td style={S.tdBase("left",   i % 2 === 0)}>{row.MillShortName}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td style={S.tfootTd("center")}>Total</td>
                    <td style={S.tfootTd("right")}></td>
                    <td style={{ ...S.tfootTd("right"), color: "#16a34a" }}>{formatReadableAmount(totalInward.toFixed(2))}</td>
                    <td style={{ ...S.tfootTd("right"), color: "#dc2626" }}>{formatReadableAmount(totalOutward.toFixed(2))}</td>
                    {[...Array(7)].map((_, i) => <td key={i} style={S.tfootTd("right")}></td>)}
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StockReportDetail;
